import { isSSR } from '../../utils/is-ssr';
import { queryApp as queryAppAction } from '@wix/ambassador-devcenter-apps-v1-app/http';
import type { Essentials } from '../../models';
import { queryMarketListing as queryMarketListingAction } from '@wix/ambassador-devcenter-app-market-listing-v1-market-listing/http';
import type { MarketListing } from '@wix/ambassador-devcenter-app-market-listing-v1-market-listing/types';
import type { V1App } from '@wix/ambassador-devcenter-apps-v1-app/types';

export async function queryApp({
  httpClient,
  rpcClient,
  slug,
}: {
  httpClient: Essentials['httpClient'];
  rpcClient?: Essentials['rpcClient'];
  slug: string;
}) {
  let app: V1App;
  const queryAppReq = {
    query: {
      filter: {
        slug,
      },
    },
  };
  if (isSSR() && rpcClient !== undefined) {
    const queryAppRpc = (
      await import('@wix/ambassador-devcenter-apps-v1-app/rpc')
    ).queryApp;
    app = await rpcClient
      .request(queryAppRpc(queryAppReq))
      .then((getAppResponse) => getAppResponse.apps?.[0] ?? {});
  } else {
    app = await httpClient
      .request(queryAppAction(queryAppReq))
      .then((getAppResponse) => getAppResponse.data.apps?.[0] ?? {});
  }
  return { ...app, id: app?.id ?? '', name: app?.name ?? '' };
}

export async function queryMarketListing({
  httpClient,
  rpcClient,
  appId,
}: {
  httpClient: Essentials['httpClient'];
  rpcClient?: Essentials['rpcClient'];
  appId: string;
}) {
  let marketListing: MarketListing;
  const queryMarketListingReq = { query: { filter: { appId } } };
  if (isSSR() && rpcClient !== undefined) {
    const queryMarketListingRpc = (
      await import(
        '@wix/ambassador-devcenter-app-market-listing-v1-market-listing/rpc'
      )
    ).queryMarketListing;
    marketListing = await rpcClient
      .request(queryMarketListingRpc(queryMarketListingReq))
      .then((getAppResponse) => getAppResponse.marketListing?.[0] ?? {});
  } else {
    marketListing = await httpClient
      .request(queryMarketListingAction(queryMarketListingReq))
      .then((getAppResponse) => getAppResponse.data.marketListing?.[0] ?? {});
  }
  return marketListing;
}
